import BidMsrpButton from '../../../../elements/BidMsrpButton/BidMsrpButton'

const MSRP = ({ msrp }: { msrp?: number }) => {
  if (!msrp) return <></>

  return (
    <div className="flex gap-1 xs:gap-2 items-end">
      <div className="text-12 font-semibold flex gap-0.5">
        MSRP <BidMsrpButton />
      </div>
      <div className="text-xl font-semibold -mb-[1px]">
        $
        {msrp.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
    </div>
  )
}

export default MSRP
